import { createAsyncThunk } from '@reduxjs/toolkit';
import { classToPlain } from 'class-transformer';
import { FORM_ERROR } from 'final-form';

import { AppError } from '@vk-hr-tek/core/error';
import { showError, showNotification } from '@vk-hr-tek/core/notifications';

import { ThunkExtra, ThunkValuesAndActions } from '@app/store';
import { VacationsService } from '@app/gen/vacations';

import { StartVacationScheduleDto } from '../../../dto';

export const startVacation = createAsyncThunk<
  void,
  ThunkValuesAndActions<StartVacationScheduleDto>,
  ThunkExtra
>(
  'settings/vacations/startVacation',
  async (
    { actions, values },
    { rejectWithValue, dispatch, extra: { inject } },
  ) => {
    try {
      const vacationsService = inject(VacationsService);

      await vacationsService.vacationScheduleStart({
        params: { schedule_id: values.scheduleId },
        body: {
          exclude_employees: values.excludeEmployeeOptions,
          ...(values.includeEmployeeHiredBefore
            ? {
                include_employee_hired_before:
                  values.includeEmployeeHiredBeforeDate,
              }
            : {}),
          ...(values.excludeDisabledContractUntil
            ? {
                exclude_disabled_contract_until:
                  values.excludeDisabledContractUntilDate,
              }
            : {}),
          ...(values.excludeMaternityLeaveUntil
            ? {
                exclude_maternity_leave_until:
                  values.excludeMaternityLeaveUntilDate,
              }
            : {}),
          ...(values.excludeUnpayedVacationUntil
            ? {
                exclude_unpayed_vacation_until:
                  values.excludeUnpayedVacationUntilDate,
              }
            : {}),
        },
      });
      dispatch(showNotification('Планирование запущено!'));
      actions.resolve(null);
    } catch (err) {
      dispatch(showError('Произошла ошибка при запуске планирования'));
      actions.reject({ [FORM_ERROR]: err });
      return rejectWithValue(classToPlain(err) as AppError);
    }
  },
);

export const settingsVacationStartReducer = () => {};
